import { useState } from 'react'

export default function ProductionWorkOrder() {
  const [orders] = useState([
    { id: 1, no: 'WO20260417001', type: '成长纪念', status: '待处理', date: '2026-04-17' },
  ])

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📋 制作工单</h2>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>工单?</th>
              <th style={th}>类型</th>
              <th style={th}>状?</th>
              <th style={th}>创建时间</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(o => (
              <tr key={o.id}>
                <td style={td}>{o.no}</td>
                <td style={td}>{o.type}</td>
                <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: '#fff', color: '#faad14' }}>{o.status}</span></td>
                <td style={{ ...td, color: '#999' }}>{o.createdAt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
